export function getCookie(cookieName) {
  const cookiePattern = new RegExp('(^|; )' + encodeURIComponent(cookieName) + '=([^;]*)');
  const match = document.cookie.match(cookiePattern);
  return match ? decodeURIComponent(match[2]) : null;
}

export function setCookie(cookieName, cookieValue, expirationInDays = 30, domain = '.sky.it') {
  let expires = '';
  if (expirationInDays) {
    const date = new Date();
    date.setTime(date.getTime() + expirationInDays * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie =
    cookieName + '=' + (cookieValue || '') + expires + '; path=/' + (domain ? '; domain=' + domain : '');
}

export function deleteCookie(cookieName) {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.sky.it`;
}

export function getExternalId() {
  return getCookie('ext');
}

export function getPeterwitt() {
  return getCookie('PETERWITT');
}
